import ReactMarkdown from "react-markdown";
import React from "react";
import { PaperClipIcon } from "@heroicons/react/20/solid";

const MessageContent = ({ message }) => {
  const hasAttachment = Boolean(message.attachment);

  return (
    <>
      {hasAttachment ? (
        <a
          href={message.attachmentLink}
          target="_blank"
          rel="noreferrer"
          className="flex items-center mb-2 underline text-blue-600 hover:text-blue-700"
        >
          <PaperClipIcon className="h-4 w-4 mr-1 flex-shrink-0" />
          <span className="truncate">{message.attachmentName}</span>
        </a>
      ) : (
        <ReactMarkdown
          components={{
            a: ({ node, children, ...props }) => (
              <a
                {...props}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-blue-500 hover:text-blue-600 underline underline-offset-2 break-words"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="size-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244"
                  />
                </svg>
                {children}
              </a>
            ),
            p: ({ node, children, ...props }) => {
              const hasOnlyLink =
                node.children.length === 1 && node.children[0].type === "link";
              if (hasOnlyLink) return <>{children}</>;
              return (
                <p {...props} className="mb-2 break-words whitespace-pre-wrap">
                  {children}
                </p>
              );
            },
            ul: ({ node, ...props }) => (
              <ul {...props} className="list-disc ml-4 mb-2 break-words" />
            ),
            ol: ({ node, ...props }) => (
              <ol {...props} className="list-decimal ml-4 mb-2 break-words" />
            ),
            li: ({ node, ...props }) => (
              <li {...props} className="mb-1 break-words" />
            ),
            code: ({ node, ...props }) => (
              <code {...props} className="bg-gray-100 rounded px-1 text-sm break-words" />
            ),
          }}
        >
          {message.message || ""}
        </ReactMarkdown>
      )}
    </>
  );
};

export default MessageContent;
